module.exports = __webpack_public_path__ + "img/detours_en_france-village_prefere_des_francais.0f9bef93.jpg";